import Img, { FluidObject } from "gatsby-image";
import React, { Component } from "react";
import { withAmp } from "../AMP/AmpContext";

type ImageInContextProps = {
  alt?: string;
  amp?: boolean;
  className?: string;
  src?: string;
  fluid?: FluidObject | FluidObject[];
  loading?: "auto" | "eager" | "lazy";
  onError?: React.ReactEventHandler<HTMLImageElement>;
  onLoad?: React.ReactEventHandler<HTMLImageElement>;
};

class ImageInContext extends Component<ImageInContextProps> {
  render() {
    const {
      // General
      alt,
      amp,
      className,
      src,
      // Gatsby Image
      fluid,
      loading, // auto, eager, lazy
      onError,
      onLoad,
    } = this.props;
    // If nothing provided, return null
    if (src == null && fluid == null) return null;

    // If amp or no fluid was provided, use src property
    const useSrc = amp === true || fluid == null;
    const imgLoading = loading === "auto" ? undefined : loading;

    // AMP pages and callers without `fluid` must use a plain <img> at runtime.
    if (useSrc) {
      return (
        <img
          className={className}
          alt={alt}
          src={(src || "").replace(/^\/\//, "https://")}
          loading={imgLoading}
          onError={onError}
          onLoad={onLoad}
        />
      );
    }

    return <Img alt={alt} className={className} fluid={fluid} loading={imgLoading} onError={onError} />;
  }
}

export default withAmp(ImageInContext);
